var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { CalendarIcon, TimerIcon } from "@radix-ui/react-icons";
import { RadixSelect } from "../primitives/RadixSelect";
import { RadixToggleGroup } from "../primitives/RadixToggleGroup";
import "./orderTimeSelectionFlyOut.css";
import { useOrderIntent } from "../../providers";
var normalizeDatetimeForUi = function (datetimeValue) {
    var _a, _b;
    var normalizedValue = String(datetimeValue || "").trim();
    if (!normalizedValue) {
        return "";
    }
    var standardFormatMatch = normalizedValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s(\d{1,2}):(\d{2})\s(AM|PM)$/i);
    if (standardFormatMatch) {
        var month = standardFormatMatch[1], day = standardFormatMatch[2], year = standardFormatMatch[3], hour = standardFormatMatch[4], minute = standardFormatMatch[5], meridiem = standardFormatMatch[6];
        return "".concat(month.padStart(2, "0"), "/").concat(day.padStart(2, "0"), "/").concat(year, " ").concat(hour.padStart(2, "0"), ":").concat(minute, " ").concat(meridiem.toUpperCase());
    }
    var dbFormatMatch = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2})(?::\d{2})?$/);
    if (dbFormatMatch) {
        var year = dbFormatMatch[1], month = dbFormatMatch[2], day = dbFormatMatch[3], hourText = dbFormatMatch[4], minute = dbFormatMatch[5];
        var hour24 = Number(hourText);
        var meridiem = hour24 >= 12 ? "PM" : "AM";
        var hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
        return "".concat(month, "/").concat(day, "/").concat(year, " ").concat(String(hour12).padStart(2, "0"), ":").concat(minute, " ").concat(meridiem);
    }
    var parsedDate = new Date(normalizedValue);
    if (!Number.isNaN(parsedDate.getTime())) {
        var storeTimezone = String(((_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.timezone) || "UTC");
        var formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: storeTimezone,
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        var formatted = formatter.format(parsedDate);
        var _c = formatted.split(", "), _d = _c[0], datePart = _d === void 0 ? "" : _d, _e = _c[1], timePart = _e === void 0 ? "" : _e;
        if (datePart && timePart) {
            return "".concat(datePart, " ").concat(timePart);
        }
    }
    return normalizedValue;
};
var getDateFromDatetime = function (datetimeValue) {
    var normalizedDatetime = normalizeDatetimeForUi(datetimeValue);
    var _a = normalizedDatetime.split(" ")[0], datePart = _a === void 0 ? "" : _a;
    return datePart;
};
var getDateLabel = function (dateValue) {
    var _a = dateValue.split("/"), _b = _a[0], month = _b === void 0 ? "" : _b, _c = _a[1], day = _c === void 0 ? "" : _c, _d = _a[2], year = _d === void 0 ? "" : _d;
    var monthNumber = Number(month);
    var dayNumber = Number(day);
    var yearNumber = Number(year);
    if (!monthNumber || !dayNumber || !yearNumber) {
        return dateValue;
    }
    var parsedDate = new Date(Date.UTC(yearNumber, monthNumber - 1, dayNumber));
    if (Number.isNaN(parsedDate.getTime())
        || parsedDate.getUTCFullYear() !== yearNumber
        || parsedDate.getUTCMonth() !== monthNumber - 1
        || parsedDate.getUTCDate() !== dayNumber) {
        return dateValue;
    }
    var dayOfWeek = new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        weekday: "long",
    }).format(parsedDate);
    return "".concat(dayOfWeek, ", ").concat(dateValue);
};
export var OrderTimeSelectionFields = function (_a) {
    var _b;
    var orderTiming = _a.orderTiming, futureOrderDatetime = _a.futureOrderDatetime, hasFutureOrdering = _a.hasFutureOrdering, futureDates = _a.futureDates, selectedFutureDate = _a.selectedFutureDate, futureDateHours = _a.futureDateHours, futureAvailabilityMessage = _a.futureAvailabilityMessage, futureAvailabilityLoading = _a.futureAvailabilityLoading, onSetAsapOrder = _a.onSetAsapOrder, onSetFutureOrder = _a.onSetFutureOrder, onSelectFutureDate = _a.onSelectFutureDate, onValidateFutureDatetime = _a.onValidateFutureDatetime, onSelectionApplied = _a.onSelectionApplied, onSelectionSuccess = _a.onSelectionSuccess, _c = _a.containerClassName, containerClassName = _c === void 0 ? "" : _c, _d = _a.canSelectAsap, canSelectAsap = _d === void 0 ? true : _d, _e = _a.canSelectFuture, canSelectFuture = _e === void 0 ? true : _e, _f = _a.disabledMessage, disabledMessage = _f === void 0 ? null : _f;
    var hasAutoSelectedSingleOptionRef = React.useRef(false);
    var hasUserDateSelectionRef = React.useRef(false);
    var getTimeLabel = function (datetimeValue) {
        var normalizedDatetime = normalizeDatetimeForUi(datetimeValue);
        var datetimeParts = normalizedDatetime.trim().split(" ");
        if (datetimeParts.length < 2) {
            return normalizedDatetime;
        }
        var _a = datetimeParts.slice(-2), _b = _a[0], timePart = _b === void 0 ? "" : _b, _c = _a[1], meridiemPart = _c === void 0 ? "" : _c;
        var _d = timePart.split(":"), _e = _d[0], hourPart = _e === void 0 ? "" : _e, _f = _d[1], minutePart = _f === void 0 ? "" : _f;
        var parsedHour = Number(hourPart);
        var normalizedHour = Number.isNaN(parsedHour) ? hourPart : String(parsedHour);
        if (!minutePart) {
            return [normalizedHour, meridiemPart].filter(Boolean).join(" ");
        }
        return "".concat(normalizedHour, ":").concat(minutePart, " ").concat(meridiemPart).trim();
    };
    var _g = React.useState(orderTiming), selectedTiming = _g[0], setSelectedTiming = _g[1];
    var _h = React.useState(selectedFutureDate || ""), selectedDate = _h[0], setSelectedDate = _h[1];
    var _j = React.useState(futureOrderDatetime || ""), selectedTime = _j[0], setSelectedTime = _j[1];
    var _k = React.useState(null), submitError = _k[0], setSubmitError = _k[1];
    var _l = React.useState(false), isLoadingDateHours = _l[0], setIsLoadingDateHours = _l[1];
    var isSelectionDisabled = Boolean(disabledMessage);
    React.useEffect(function () {
        setSelectedTiming(orderTiming);
        setSubmitError(null);
    }, [orderTiming]);
    React.useEffect(function () {
        if (hasUserDateSelectionRef.current && selectedDate) {
            return;
        }
        var deferredDate = getDateFromDatetime(futureOrderDatetime || "");
        if (deferredDate) {
            setSelectedDate(deferredDate);
            return;
        }
        setSelectedDate(selectedFutureDate || "");
    }, [futureOrderDatetime, selectedDate, selectedFutureDate]);
    React.useEffect(function () {
        var normalizedDatetime = normalizeDatetimeForUi(futureOrderDatetime || "");
        var deferredDate = getDateFromDatetime(normalizedDatetime);
        setSelectedTime(normalizedDatetime);
        if (!deferredDate) {
            return;
        }
        var shouldSyncDateOptions = deferredDate !== selectedDate;
        setSelectedDate(deferredDate);
        if (!shouldSyncDateOptions) {
            return;
        }
        onSelectFutureDate(deferredDate, false).catch(function () {
            // handled by provider message state
        });
    }, [futureOrderDatetime, onSelectFutureDate, selectedDate]);
    var normalizedDeferredDatetime = normalizeDatetimeForUi(futureOrderDatetime || "");
    var deferredDateFromDatetime = getDateFromDatetime(normalizedDeferredDatetime);
    var dateOptions = React.useMemo(function () {
        var options = __spreadArray([], futureDates, true);
        if (selectedDate && !options.includes(selectedDate)) {
            options.push(selectedDate);
        }
        if (deferredDateFromDatetime && !options.includes(deferredDateFromDatetime)) {
            options.push(deferredDateFromDatetime);
        }
        return options;
    }, [deferredDateFromDatetime, futureDates, selectedDate]);
    var timeOptions = React.useMemo(function () {
        var normalizedHours = futureDateHours.map(function (hour) { return normalizeDatetimeForUi(hour); });
        if (selectedTime && !normalizedHours.includes(selectedTime)) {
            normalizedHours.push(selectedTime);
        }
        if (normalizedDeferredDatetime && !normalizedHours.includes(normalizedDeferredDatetime)) {
            normalizedHours.push(normalizedDeferredDatetime);
        }
        return normalizedHours;
    }, [futureDateHours, normalizedDeferredDatetime, selectedTime]);
    var canShowFutureOption = hasFutureOrdering && (futureAvailabilityLoading || futureDates.length > 0);
    React.useEffect(function () {
        if (isSelectionDisabled) {
            return;
        }
        if (!canSelectFuture && selectedTiming === "future") {
            setSelectedTiming("asap");
        }
    }, [canSelectFuture, isSelectionDisabled, selectedTiming]);
    React.useEffect(function () {
        if (isSelectionDisabled) {
            hasAutoSelectedSingleOptionRef.current = false;
            return;
        }
        if (canSelectAsap && canSelectFuture) {
            hasAutoSelectedSingleOptionRef.current = false;
            return;
        }
        if (hasAutoSelectedSingleOptionRef.current) {
            return;
        }
        if (!canSelectAsap && canSelectFuture) {
            setSelectedTiming("future");
            hasAutoSelectedSingleOptionRef.current = true;
            return;
        }
        if (canSelectAsap && !canSelectFuture) {
            setSelectedTiming("asap");
            hasAutoSelectedSingleOptionRef.current = true;
            void applyAsapSelection();
        }
    }, [canSelectAsap, canSelectFuture, isSelectionDisabled]);
    var applyFutureSelection = function (selectedDatetime) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitError(null);
                    if (isSelectionDisabled) {
                        return [2 /*return*/];
                    }
                    if (!hasFutureOrdering || !canSelectFuture) {
                        setSubmitError("Future ordering is currently unavailable.");
                        return [2 /*return*/];
                    }
                    if (!selectedDatetime) {
                        setSubmitError("Please choose a future time.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, onValidateFutureDatetime(selectedDatetime)];
                case 2:
                    isValid = _a.sent();
                    if (!isValid) {
                        setSubmitError("The selected future time is invalid. Please choose another time.");
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, onSetFutureOrder(selectedDatetime)];
                case 3:
                    _a.sent();
                    onSelectionSuccess === null || onSelectionSuccess === void 0 ? void 0 : onSelectionSuccess("future");
                    onSelectionApplied === null || onSelectionApplied === void 0 ? void 0 : onSelectionApplied();
                    return [3 /*break*/, 5];
                case 4:
                    _error_1 = _a.sent();
                    setSubmitError("We couldn't validate that future time. Please refresh the page and try again.");
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var applyAsapSelection = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitError(null);
                    if (isSelectionDisabled) {
                        return [2 /*return*/];
                    }
                    if (!canSelectAsap) {
                        setSubmitError("ASAP ordering is currently unavailable.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onSetAsapOrder()];
                case 2:
                    _a.sent();
                    onSelectionSuccess === null || onSelectionSuccess === void 0 ? void 0 : onSelectionSuccess("asap");
                    onSelectionApplied === null || onSelectionApplied === void 0 ? void 0 : onSelectionApplied();
                    return [3 /*break*/, 4];
                case 3:
                    _error_2 = _a.sent();
                    setSubmitError("We couldn't switch to ASAP. Please try again.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var futureSelectionBlockedMessage = !hasFutureOrdering || !canSelectFuture
        ? "Future orders are not available for this store right now."
        : null;
    var orderIntent = useOrderIntent();
    var asapOptionLabel = canSelectAsap ? React.createElement("span", null,
        "ASAP \u2022 ", (_b = orderIntent.serviceType) === null || _b === void 0 ? void 0 :
        _b.current_time,
        " mins") : React.createElement("span", null,
        "ASAP ",
        React.createElement("em", { className: "order-time-selection-flyout__unavailable-text" }, "(Unavailable)"));
    var futureOptionLabel = canSelectFuture ? "Future" : React.createElement("span", null,
        "Future ",
        React.createElement("em", { className: "order-time-selection-flyout__unavailable-text" }, "(Unavailable)"));
    var classes = [
        "order-time-selection-flyout",
        isSelectionDisabled ? "order-time-selection-flyout--disabled" : "",
        containerClassName,
    ].filter(Boolean).join(" ");
    return (React.createElement("div", { className: classes },
        disabledMessage ? (React.createElement("p", { className: "order-time-selection-flyout__message", role: "status" }, disabledMessage)) : null,
        React.createElement(RadixToggleGroup, { ariaLabel: "Order time options", value: selectedTiming, className: "order-time-selection-flyout__timing-toggle", optionClassName: "order-time-selection-flyout__timing-toggle-item", onValueChange: function (value) {
                if (isSelectionDisabled) {
                    return;
                }
                if (value === "asap" && canSelectAsap) {
                    setSelectedTiming("asap");
                    void applyAsapSelection();
                    return;
                }
                if (value === "future" && canShowFutureOption && canSelectFuture) {
                    setSelectedTiming("future");
                }
            }, options: [
                { value: "asap", label: asapOptionLabel, icon: React.createElement(TimerIcon, null), disabled: isSelectionDisabled || !canSelectAsap },
                { value: "future", label: futureOptionLabel, icon: React.createElement(CalendarIcon, null), disabled: isSelectionDisabled || !canSelectFuture },
            ] }),
        selectedTiming === "future" ? (React.createElement("div", { className: "order-time-selection-flyout__future-container" }, futureSelectionBlockedMessage ? (React.createElement("p", { className: "order-time-selection-flyout__message", role: "status" }, futureSelectionBlockedMessage)) : (React.createElement(React.Fragment, null,
            futureAvailabilityMessage ? (React.createElement("p", { className: "order-time-selection-flyout__message", role: "status" }, futureAvailabilityMessage)) : null,
            React.createElement("div", { className: "order-time-selection-flyout__field" },
                React.createElement(RadixSelect, { id: "order-time-selection-date", label: "Order Date", wrapperClassName: "order-time-selection-flyout__select-wrapper", value: selectedDate, placeholder: "Select a future date", options: dateOptions.map(function (date) { return ({ value: date, label: getDateLabel(date) }); }), onChange: function (event) {
                        var nextDate = event.target.value;
                        setSelectedDate(nextDate);
                        setSelectedTime("");
                        setIsLoadingDateHours(true);
                        hasUserDateSelectionRef.current = true;
                        onSelectFutureDate(nextDate, true)
                            .catch(function () {
                            // handled by provider message state
                        })
                            .finally(function () {
                            hasUserDateSelectionRef.current = false;
                            setIsLoadingDateHours(false);
                        });
                    }, disabled: isSelectionDisabled || futureAvailabilityLoading || isLoadingDateHours })),
            React.createElement("div", { className: "order-time-selection-flyout__field" },
                React.createElement(RadixSelect, { id: "order-time-selection-time", label: "Order Time", wrapperClassName: "order-time-selection-flyout__select-wrapper", value: selectedTime, placeholder: "Select a future time", options: timeOptions.map(function (normalizedHour) {
                        return {
                            value: normalizedHour,
                            label: getTimeLabel(normalizedHour),
                        };
                    }), onChange: function (event) {
                        var nextTime = event.target.value;
                        setSelectedTime(nextTime);
                        void applyFutureSelection(nextTime);
                    }, disabled: isSelectionDisabled || !selectedDate || futureDateHours.length === 0 || futureAvailabilityLoading || isLoadingDateHours })),
            futureAvailabilityLoading || isLoadingDateHours ? (React.createElement("p", { className: "order-time-selection-flyout__message", role: "status" }, "Loading future times...")) : null)))) : null,
        submitError ? React.createElement("p", { className: "order-time-selection-flyout__error" }, submitError) : null));
};
